import Blink from '@components/Blink'
import config from '@config'
import { ViewportTypeValues } from '@contexts/viewport'
import useViewportType from '@hooks/useViewportType'
import { desktopCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'
import Placeholder from './Placeholder'
import { VideoZattooProps } from './types'
import { createZattooUrl } from './utils'

const {
  zattoo: { mobileStreamUrl, desktopStreamUrl },
} = config

const StyledWrapper = styled(Blink)<Pick<VideoZattooProps, 'inline'>>`
  ${({
    theme: {
      measures: {
        content: { defaultMargin },
      },
    },
    inline,
  }) => css`
    display: block;
    margin: ${defaultMargin} 0;
    ${inline &&
    css`
      ${desktopCSS(css`
        margin-left: -40px;
        margin-right: -40px;
      `)}

      ${tabletCSS(css`
        margin-left: -72px;
        margin-right: -72px;
      `)}
    `}
  `}
`

const VideoZattoo: FunctionComponent<VideoZattooProps> = ({
  channel,
  inline,
}) => {
  const viewportType = useViewportType()

  // use dynamic url resolution here to prevent server side render inconsistency in
  // `href` property because of inability to determine device type on server
  const url = createZattooUrl(
    viewportType === ViewportTypeValues.DESKTOP
      ? desktopStreamUrl
      : mobileStreamUrl,
    channel
  )

  return (
    <StyledWrapper href={url} target="_blank" rel="noopener" inline={!!inline}>
      <Placeholder channel={channel} inline={!!inline} />
    </StyledWrapper>
  )
}

export default VideoZattoo
